import api from '../api';

export const getApprovers = async (projectId) => {
  const res = await api.get('/users/with-approver-role', { params: { projectId } });
  return res.data.users || [];
};
